import { Component, Input, OnInit } from '@angular/core';
import { PlayerClass } from 'src/app/models/models';

@Component({
  selector: 'app-player-class-editor',
  templateUrl: './player-class-editor.component.html',
  styleUrls: ['./player-class-editor.component.scss']
})
export class PlayerClassEditorComponent implements OnInit {

  @Input()
  model: PlayerClass

  constructor() {
    this.model = {
      name: '',
      parent: undefined,
      skills: [],
      levelup:
      {
        attribute_point: 0,
        attribute: {}
      }
    }
  }

  ngOnInit(): void {


  }

}
